import { PARTITION } from './constants';
import type { ReduxState } from './reducer';

const selectPartition = (state: any): ReduxState => state[PARTITION];
const selectStep = (state: any) => selectPartition(state) && selectPartition(state).step;
const selectMobileNumber = (state: any) => selectPartition(state) && selectPartition(state).mobileNumber;

export default {
  selectPartition,
  selectStep,
  selectMobileNumber,
};
